import { Field, FixedOptionTextOutput, NumericInput } from 'Components/Core';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import React from 'react';
import { NamePrefixModifier, withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { ListFieldSection, PageSection } from '../../../../Layout';
import AsNfdReading from './NuclearDensityReading';
const Section: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  return (
    <PageSection heading="Measurements">
      <NamePrefixModifier appendNamePrefix="Measurements">
        <ListFieldSection>
          <Field input={<FixedOptionTextOutput />} name="NuclearDensityGaugeMode" />
          <Field input={<NumericInput />} name="Depth" />
        </ListFieldSection>
        <AsNfdReading />
      </NamePrefixModifier>
    </PageSection>
  );
};

const AsMeasurementSection = withInjectedProps(Section);

export { AsMeasurementSection };
export default AsMeasurementSection;
